const nserial2 = '090123456789'
const nserial3 = '890123456789'
const logarithm = ['05', '16', '27', '38', '49', '50', '61', '72', '83', '94']

const posMapping = {
  '前': '百',
  '中': '十',
  '后': '个',
  '前二': '百十',
  '后二': '十个',
  '1位': '百',
  '2位': '十',
  '3位': '个',
  '12位': '百十',
  '13位': '百个',
  '23位': '十个',
  '123位': '百十个'
}

const codePosMapping = {
  OXX: '百',
  XOX: '十',
  XXO: '个',
  OOX: '百十',
  OXO: '百个',
  XOO: '十个',
  OOO: '百十个'
}
const posCodeMapping = Object.fromEntries(Object.entries(codePosMapping).map(([k, v]) => [v, k]))

export function parse(cmd, defaultMethod = '') {
  const positions = []
  const numbers = []
  const options = []
  let amount = NaN

  let buf = []
  let prev = ''
  let flexible = true
  let amountSeparator = false
  let singles = true
  const errors = []

  for (let i = 0; i < cmd.length; i++) {
    const c = cmd[i]
    switch (c) {
      case '百':
      case '十':
      case '个':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
      case '前':
      case '中':
      case '后':
        if (prev !== 'p') { prev = 'p' }
        buf.push(c)
        break
      case '位':
        if (prev === 'n' && buf.length) {
          positions.push(...(posMapping[`${buf.join('')}${c}`] ?? ''))
          buf = []
        }
        break
      case '二':
      case '三':
        if (prev === 'o') {
          buf.push(c)
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf, c)
          buf = []
        }
        break
      case '全':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (cmd.at(i + 1) === '转') {
          if (prev !== 'o') { prev = 'o' }
          buf.push(c)
          break
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('0123456789')
        break
      case '单':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('13579')
        break
      case '双':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('02468')
        break
      case '大':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('56789')
        break
      case '小':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        numbers.push('01234')
        break
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        if (prev === 'o') {
          buf.push(c)
          break
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        }
        if (prev !== 'n') { prev = 'n' }
        buf.push(c)
        break
      case '.':
        buf.push(c)
        break
      case ' ':
        if (prev === 'p' && buf.length) {
          positions.push(...buf)
          flexible = false
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          flexible = false
          buf = []
        }
        break
      case '/':
        amountSeparator = true
      case '-':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        break
      case '各':
        singles = false
      case '=':
        amountSeparator = true
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        break
      case '去':
        if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        } else if (prev === 'p' && buf.length) {
          positions.push(...buf)
          buf = []
        } else if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
        if (prev !== 'o') { prev = 'o' }
        buf.push(c)
        break
      case '对':
      case '数':
        buf.push(c)
        break
      case '重':
      case '兄':
        if (prev === 'o') {
          options.push([...buf, c].join(''))
          buf = []
        }
        break
      case '取':
        if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        } else if (prev === 'o' && buf.length) {
          options.push(buf.join(''))
          buf = []
        }
      case '合':
        if (prev === 'o' && buf.length && !Number.isNaN(Number(buf.at(-1)))) {
          options.push(buf.join(''))
          buf = []
        }
        if (prev === 'n' && buf.length) {
          numbers.push(buf.join(''))
          buf = []
        }
      case '转':
        if (prev !== 'o') { prev = 'o' }
        buf.push(c)
        break
    default:
        errors.push(c)
    }
  }
  if (errors.length) {
    return { error: `指令"${cmd}"包含错误字符"${errors.join('')}"` }
  }
  if (buf.length && amountSeparator) {
    amount = Number(buf.join(''))
  }
  if (Number.isNaN(amount)) {
    return { error: `指令"${cmd}"没有金额` }
  }
  if (amount <= 0) {
    return { error: `指令"${cmd}"金额不正确` }
  }

  let method = positions.length ? positions.join('') : defaultMethod
  method = posCodeMapping[posMapping[method] ?? method] ?? method
  for (let i = 0; i < method.length; i++) {
    if (method[i] !== 'O' && method[i] !== 'X') {
      return { error: `指令"${cmd}"不正确` }
    }
  }

  for (let i = 0; i < options.length; i++) {
    const o = options[i]
    if (['去重', '去三重', '去二兄', '去三兄'].indexOf(o) > -1) {
    } else if (o.startsWith('合')) {
      if (Number.isNaN(Number(o.slice(1)))) {
        return { error: `指令"${cmd}"选项"${o.slice(0, 1)}"参数不正确` }
      }
    } else if (o.startsWith('取二合') || o.startsWith('取三合')) {
      if (Number.isNaN(Number(o.slice(3)))) {
        return { error: `指令"${cmd}"选项"${o.slice(0, 3)}"参数不正确` }
      }
    } else if (o.startsWith('全转')) {
      numbers.push(o.slice(2))
      options[i] = '去重'
    } else if (o.startsWith('去对数')) {
      const n = o.slice(3)
      if (n.length > 6 || Number.isNaN(Number(n))) {
        return { error: `指令"${cmd}"去对数参数不正确` }
      }
    } else {
      return { error: `指令"${cmd}"选项"${o}"不正确` }
    }
  }

  const n = method.match(/O/g).length
  if (n !== numbers.length) {
    if (numbers.length !== 1 && flexible) {
      return { error: `指令"${cmd}"的数字组合长度不正确` }
    }
    if (!singles || n !== numbers[0].length) {
      while (numbers.length < n) {
        numbers.push(numbers.at(0))
      }
    }
  }
  if (!flexible) {
    for (let i = 0; i < numbers.length; i++) {
      if (numbers[i].length !== n) {
        return { error: `指令"${cmd}"的数字组合长度不正确` }
      }
    }
  }
  for (let i = 0; i < options.length; i++) {
    const m = options[i].match(/合(\d+)?/)
    if (m && m[1] === undefined) {
      return { error: `指令"${cmd}"合的参数不正确` }
    }
  }

  return { method, numbers: numbers.map(e => [...new Set(e)].join('')), amount, flexible, options }
}

export function output(parsed) {
  const numbers = []
  const n = parsed.method.match(/O/g).length

  if (!parsed.flexible) {
    for (const arr of parsed.numbers) {
      if (n === 3) {
        numbers.push(arr)
      }
      if (n === 2) {
        let num = parsed.method
        numbers.push(num.replace('O', arr[0]).replace('O', arr[1]))
      }
    }
    return numbers
  }

  const onlySum = parsed.options.find(e => e.startsWith('合'))

  if (n === 1) {
    const arr = parsed.numbers[0]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr.length; a++) {
      if (sum) {
        const n1 = Number(arr[a])
        let found = false
        for (let i = 0; i < sum.length; i++) {
          if (sum[i] === n1) {
            found = true
            break
          }
        }
        if (!found) continue
      }
      let num = parsed.method
      numbers.push(num.replace('O', arr[a]))
    }
    return numbers
  }

  const removeDuplicates = parsed.options.indexOf('去重') > -1
  const removeBrothers = parsed.options.indexOf('去二兄') > -1
  const removeLogarithm = parsed.options.find(e => e.startsWith('去对数'))
  const onlySum2 = parsed.options.find(e => e.startsWith('取二合'))

  if (n === 2) {
    const arr1 = parsed.numbers[0]
    if (parsed.numbers.length === 1) {
      let num = parsed.method
      numbers.push(num.replace('O', arr1[0]).replace('O', arr1[1]))
      return numbers
    }
    const arr2 = parsed.numbers[1]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    const sum2 = onlySum2 ? onlySum2.slice(3).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr1.length; a++) {
      for (let b = 0; b < arr2.length; b++) {
        const n1 = arr1[a], n2 = arr2[b]
        if (removeDuplicates && n1 === n2) {
          continue
        }
        if (removeBrothers) {
          const r = [n1, n2]
          r.sort()
          if (nserial2.indexOf(`${r[0]}${r[1]}`) > -1) {
            continue
          }
        }
        if (removeLogarithm) {
          const r = [n1, n2]
          r.sort()
          if (logarithm.indexOf(`${r[0]}${r[1]}`) > -1) {
            const nums = removeLogarithm.slice(3)
            if (!nums) {
              continue
            }
            if (
              nums.indexOf(n1) > -1
              || nums.indexOf(n2) > -1
            ) {
              continue
            }
          }
        }
        if (sum) {
          const r = (Number(n1) + Number(n2)) % 10
          let found = false
          for (let i = 0; i < sum.length; i++) {
            if (sum[i] === r) {
              found = true
              break
            }
          }
          if (!found) continue
        }
        if (sum2) {
          const r = (Number(n1) + Number(n2)) % 10
          let found = false
          for (let i = 0; i < sum2.length; i++) {
            if (sum2[i] === r) {
              found = true
              break
            }
          }
          if (!found) continue
        }
        let num = parsed.method
        numbers.push(num.replace('O', arr1[a]).replace('O', arr2[b]))
      }
    }
    return numbers
  }

  const removeDuplicates3 = parsed.options.indexOf('去三重') > -1
  const removeBrothers3 = parsed.options.indexOf('去三兄') > -1
  const onlySum3 = parsed.options.find(e => e.startsWith('取三合'))

  if (n === 3) {
    const arr1 = parsed.numbers[0]
    if (parsed.numbers.length === 1) {
      let num = parsed.method
      numbers.push(num.replace('O', arr1[0]).replace('O', arr1[1]).replace('O', arr1[2]))
      return numbers
    }
    const arr2 = parsed.numbers[1], arr3 = parsed.numbers[2]
    const sum = onlySum ? onlySum.slice(1).split('').map(e => Number(e)) : false
    const sum2 = onlySum2 ? onlySum2.slice(3).split('').map(e => Number(e)) : false
    const sum3 = onlySum3 ? onlySum3.slice(3).split('').map(e => Number(e)) : false
    for (let a = 0; a < arr1.length; a++) {
      for (let b = 0; b < arr2.length; b++) {
        for (let c = 0; c < arr3.length; c++) {
          const n1 = arr1[a], n2 = arr2[b], n3 = arr3[c]
          if (removeDuplicates && (n1 === n2 || n1 === n3 || n2 === n3)) {
            continue
          }
          if (removeDuplicates3 && n1 === n2 && n1 === n3) {
            continue
          }
          if (removeBrothers) {
            const r = [n1, n2, n3]
            r.sort()
            r.push(r[0])
            if (
              nserial2.indexOf(`${r[0]}${r[1]}`) > -1
              || nserial2.indexOf(`${r[1]}${r[2]}`) > -1
              || nserial2.indexOf(`${r[2]}${r[3]}`) > -1
            ) {
              continue
            }
          }
          if (removeBrothers3) {
            const r = [n1, n2, n3]
            r.sort()
            r.push(r[0], r[1])
            if (
              nserial3.indexOf(`${r[0]}${r[1]}${r[2]}`) > -1
              || nserial3.indexOf(`${r[1]}${r[2]}${r[3]}`) > -1
              || nserial3.indexOf(`${r[2]}${r[3]}${r[4]}`) > -1
            ) {
              continue
            }
          }
          if (removeLogarithm) {
            const r = [n1, n2, n3]
            r.sort()
            if (([
              `${r[0]}${r[1]}`, `${r[0]}${r[2]}`, `${r[1]}${r[2]}`
            ]).some(e => logarithm.indexOf(e) > -1)) {
              const nums = removeLogarithm.slice(3)
              if (!nums) {
                continue
              }
              if (
                nums.indexOf(n1) > -1
                || nums.indexOf(n2) > -1
                || nums.indexOf(n3) > -1
              ) {
                continue
              }
            }
          }
          if (sum) {
            const r = (Number(n1) + Number(n2) + Number(n3)) % 10
            let found = false
            for (let i = 0; i < sum.length; i++) {
              if (sum[i] === r) {
                found = true
                break
              }
            }
            if (!found) { continue }
          }
          if (sum2) {
            const r = [
              (Number(n1) + Number(n2)) % 10,
              (Number(n1) + Number(n3)) % 10,
              (Number(n2) + Number(n3)) % 10
            ]
            let found = false
            for (let i = 0; i < sum2.length; i++) {
              for (let j = 0; j < r.length; j++) {
                if (sum2[i] === r[j]) {
                  found = true
                  break
                }
              }
              if (found) { break }
            }
            if (!found) { continue }
          }
          if (sum3) {
            const r = (Number(n1) + Number(n2) + Number(n3)) % 10
            let found = false
            for (let i = 0; i < sum3.length; i++) {
              if (sum3[i] === r) {
                found = true
                break
              }
            }
            if (!found) { continue }
          }
          numbers.push(`${arr1[a]}${arr2[b]}${arr3[c]}`)
        }
      }
    }
    return numbers
  }

  return numbers
}
